import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import withStyles from 'react-jss';
import { map, addIndex } from 'ramda';

import { Timeslice } from 'scenes/Report/Report.helper';
import { ClassProp } from 'helpers/types';
import { CLOFBasedKeyMetric } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOverview/sections/KeyMetricGraphs/KeyMetricGraphs.helpers';
import { LiftResults } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantLift/MerchantLift.helpers';

import styles from './Calendar.styles';

type Props = {
  classes: ClassProp<typeof styles>;
  liftResults: LiftResults[] | CLOFBasedKeyMetric[];
  timeslice: Timeslice;
  chartType: string;
};

const WEEKEND_DAYS = ['Saturday', 'Sunday'];

const mapIndexed = addIndex<any>(map);

const renderDay = (
  classes: ClassProp<typeof styles>,
  timeslice: Timeslice,
  lastDayIndex: number,
  lastDay: string | Date,
  chartType: string,
) => ({ periodStart }: LiftResults, index: number) => {
  const date = moment(periodStart);
  const dayOfWeek = date.format('dddd');
  const isWeekend =
    WEEKEND_DAYS.indexOf(dayOfWeek) >= 0 && timeslice === 'DAILY';
  const showLastDay = lastDayIndex - 1 === index;
  const isMonthly = moment(lastDay).isSame(moment(lastDay).startOf('month'));
  const isFirstOfMonth =
    date.isSame(moment(periodStart).startOf('month')) || index === 0;

  if (lastDayIndex === index) {
    return null;
  }

  return (
    <span
      key={`${chartType}_${periodStart.toString()}`}
      className={classnames(classes.gridElement, { weekend: isWeekend })}
    >
      {isWeekend && <div className={classes.colLabel}> {dayOfWeek} </div>}

      <div
        className={classnames(classes.colDate, {
          firstOfMonth: isFirstOfMonth,
        })}
      >
        <div className={classes.day}>{date.format('DD')}</div>

        {isFirstOfMonth && (
          <div className={classes.month}>{date.format('MMM')}</div>
        )}
      </div>

      {showLastDay && (
        <div
          className={classnames(classes.colDate, 'lastDay', {
            monthly: isMonthly,
          })}
        >
          <div className={classes.day}>
            {moment(lastDay || date).format('DD')}
          </div>

          {isMonthly && (
            <div className={classes.month}>
              {moment(lastDay || date).format('MMM')}
            </div>
          )}
        </div>
      )}
    </span>
  );
};

const Calendar: FunctionComponent<Props> = ({
  classes,
  liftResults,
  timeslice,
  chartType,
}) => {
  const lastDayIndex = liftResults.length - 1;
  const lastResult = liftResults[lastDayIndex] || {};
  const lastDayDate = lastResult.periodStart || lastResult.periodEnd;

  return (
    <div
      className={classes.grid}
      style={{
        gridTemplateColumns: `repeat(${lastDayIndex}, ${
          lastDayIndex + 1 / lastDayIndex
        }fr)`,
      }}
    >
      {mapIndexed(
        renderDay(classes, timeslice, lastDayIndex, lastDayDate, chartType),
        liftResults,
      )}
    </div>
  );
};
export default withStyles(styles)(Calendar);
